import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "locationPin"
const LocationPinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M19 10c0 5.091-5.924 11.073-6.175 11.325a1.165 1.165 0 0 1-1.65 0C10.922 21.073 5 15.091 5 10c0-3.86 3.14-7 7-7s7 3.14 7 7zm-7 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
        </svg>
      }
    </span>
  )
}
export default LocationPinIcon
